<template>
  <div :id="id" :echartTitle="echartTitle">
    <table>
      <tr><td colspan="3" style="font-family: 微软雅黑;font-size: 1.6rem;color: #F0F3F4; text-align: center">重点设备运行寿命监控</td></tr>

      <tr class="tr-height" v-for="(item,index) in lists" :key="index">
        <td class="title-style-n">{{item.name}}&nbsp;</td>
        <td><dv-percent-pond :config="item.config" style="width:30rem;height:2.2rem" /></td>
        <td class="title-style-n">&nbsp;[{{ item.lifeTime }}月]</td>
      </tr>

    </table>

  </div>
</template>

<script>

import EmCommonApi from "@/mixin/em/common/api";

export default {
  name: "dvCenterMapLevel",
  mixins: [EmCommonApi],
  props: {
    id: String,
    echartTitle: String,
  },
  data() {
    return {
      lists:[
        {
          name: "",
          lifeTime: 0,
          config: {
            value: 0,
            formatter: '{value}%',
          }
        }
      ],
    }
  },
  created() {
    this.getRemoteData();

  },
  mounted() {

    //定时轮巡查询
    this.fresh = setInterval(() => {
      this.getRemoteData();
      // window.addEventListener('resize', this.chart.resize, false)
    },  2000);

  },
  beforeDestroy() {
    clearInterval(this.fresh);
  },
  methods: {
    getRemoteData() {

      let _url = this.$_emApiMixin_entityBaseApi("emSicEafmREocEmrec") + "/getEmSicLifeCycle";
      this.$_emApiMixin_get(_url,)
          .then((res) => {
            console.log("使用寿命：")
            console.log(res)
            //每次循环提取前要清空，否则会累加push
            // this.productData[0] = [];
            // this.productData[1] = [];
            //
            this.lists = [];
            for(let i in res){
              this.$set(this.lists,i,
                  {
                    name: res[i].sdlName,
                    lifeTime: res[i].sdlLivetime,
                    config:{
                      value: res[i].sdlLifePrcent,
                      formatter: '{value}%'
                    }
                  }
              )
            }

          })

    },

  }
}
</script>

<style scoped>
  .tr-height{
    height: 3rem;
  }
  .title-style-n{
    font-size:1.2rem;
    color:#66FF99;
  }
  .title-style-s{
    font-size:1.2rem;
    color:#00FFFF;
  }
</style>
